import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslations } from 'next-intl';

import { Button } from '../../ui/button';
import { Form } from '../../ui/form';
import { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot } from '../../ui/input-otp';

import { codeSchema } from '../../../lib/utils/validation';
import { OTP_LENGTH } from '../../../lib/constants/auth';

interface CodeFormData {
  code: string;
}

interface OTPFormProps {
  otpValue: string;
  isLoading: boolean;
  isSubmittingCode: boolean;
  onOTPChange: (value: string) => void;
  onOTPComplete: (value: string) => void;
  onBack: () => void;
}

export const OTPForm: React.FC<OTPFormProps> = ({
  otpValue,
  isLoading,
  isSubmittingCode,
  onOTPChange,
  onOTPComplete,
  onBack,
}) => {
  const t = useTranslations('AuthWithOTPButton');

  const codeForm = useForm<CodeFormData>({
    resolver: zodResolver(codeSchema),
    defaultValues: {
      code: '',
    },
    mode: 'onChange',
  });

  // Reset form when component mounts
  useEffect(() => {
    codeForm.reset({ code: '' });
  }, [codeForm]);

  return (
    <div className='space-y-6'>
      <Form {...codeForm}>
        <form className='space-y-6' key='otp-form'>
          <div className='space-y-4 flex flex-col items-center justify-center'>
            <InputOTP
              key='otp-input'
              maxLength={OTP_LENGTH}
              value={otpValue}
              onChange={onOTPChange}
              onComplete={onOTPComplete}
              className='flex justify-center'
              disabled={isLoading}
            >
              <InputOTPGroup>
                <InputOTPSlot index={0} />
                <InputOTPSlot index={1} />
                <InputOTPSlot index={2} />
              </InputOTPGroup>
              <InputOTPSeparator />
              <InputOTPGroup>
                <InputOTPSlot index={3} />
                <InputOTPSlot index={4} />
                <InputOTPSlot index={5} />
              </InputOTPGroup>
            </InputOTP>
          </div>

          <div className='flex justify-center'>
            <Button
              variant='ghost'
              size='sm'
              className='text-gray-700 hover:text-gray-900'
              onClick={onBack}
              disabled={isSubmittingCode}
            >
              {t('back')}
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
};
